module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "prest-log-email-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "overlay-loading"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column all-start prest-complementar-container"
  }, [_c('b-container', {
    staticClass: "prest-table",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "fields": _vm.table.fields,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "filter": _vm.table.filter,
      "empty-text": "Nenhum registro encontrado",
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "created_at",
      fn: function(row) {
        return [_c('span', [_vm._v(_vm._s(_vm.moment(row.value).format('DD/MM/YYYY HH:mm')))])]
      }
    }])
  }), _vm._v(" "), _c('b-row', {
    staticClass: "row-flex all-end"
  }, [_vm._v("\n                " + _vm._s(_vm.table.totalRows) + " registro(s) encontrado(s).\n              ")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "8",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-centered prest-fechar-email-button",
    on: {
      "click": _vm.fecharEmails
    }
  }, [_vm._v("\n        Fechar "), _c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-flex centered-between"
  }, [_c('h4', {
    staticClass: "prest-box-title row-flex centered-start"
  }, [_vm._v("Log de e-mails"), _c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c9e0dd0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/prestacaoContasSimplificado/PrestacaoSimplificadaEmails.vue
// module id = 1923
// module chunks = 1